/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_LandscapingInputs */

const en_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landscaping`)
};

const es_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paisajismo`)
};

const fr_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aménagement paysager`)
};

const de_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landschaftsbau`)
};

const ja_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`造園`)
};

const zh_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`园林绿化`)
};

const ar_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنسيق حدائق`)
};

const id_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanskap`)
};

const it_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progettazione del Paesaggio`)
};

const ru_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ландшафтный дизайн`)
};

const pt_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paisagismo`)
};

const ko_val_landscaping = /** @type {(inputs: Val_LandscapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`조경`)
};

/**
* | output |
* | --- |
* | "Landscaping" |
*
* @param {Val_LandscapingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_landscaping = /** @type {((inputs?: Val_LandscapingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_LandscapingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_landscaping(inputs)
	if (locale === "es") return es_val_landscaping(inputs)
	if (locale === "fr") return fr_val_landscaping(inputs)
	if (locale === "de") return de_val_landscaping(inputs)
	if (locale === "ja") return ja_val_landscaping(inputs)
	if (locale === "zh") return zh_val_landscaping(inputs)
	if (locale === "ar") return ar_val_landscaping(inputs)
	if (locale === "id") return id_val_landscaping(inputs)
	if (locale === "it") return it_val_landscaping(inputs)
	if (locale === "ru") return ru_val_landscaping(inputs)
	if (locale === "pt") return pt_val_landscaping(inputs)
	return ko_val_landscaping(inputs)
});